import { render } from "./manage-agenda-appointment-types.vue?vue&type=template&id=2eb1cb8c"
import script from "./manage-agenda-appointment-types.vue?vue&type=script&lang=js"
export * from "./manage-agenda-appointment-types.vue?vue&type=script&lang=js"
script.render = render

export default script